import React, { useState, useEffect, useRef } from "react";
import "./userpage.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { database } from "../../database/firebase";
import { getFirestore, increment, serverTimestamp, doc, getDoc, updateDoc, setDoc, collection, query, orderBy, where, getDocs, onSnapshot, limit, listCollections, Timestamp } from "firebase/firestore";
import UseHandleConnection from "../../functions/UseHandleConnection";
import Swal from "sweetalert2"; // Import SweetAlert2 for better UI feedback
import axios from "axios";

/** Must match `.question-screen { transition: … }` in userpage.css */
const QUESTION_POPUP_TRANSITION_MS = 1000;

function UserPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLive, setIsLive] = useState(false);
  const [questionForm, setQuestionForm] = useState({});
  const [userData, setUserData] = useState(null);
  const [currentQueston, setCurrentQueston] = useState(0);
  /** Index shown in the popup; lags `currentQueston` until the slide-up animation finishes */
  const [displayedQuestionIndex, setDisplayedQuestionIndex] = useState(0);
  const [alldata, setAllData] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isQuestionCompleted, setIsQuestionCompleted] = useState(false);
  const [themeData, setThemeData] = useState(null);
  const [waitingScreen, setWaitingScreen] = useState(false);
  const [seleteduser, seleteduserScreen] = useState(false);
  const [seleteduserimg, seleteduserimgScreen] = useState(false);
  const [seletedusername, seletedusernameScreen] = useState(false);
  const [slideData, setSlideData] = useState(null);
  const [totalAnswered, setTotalAnswered] = useState(0);
  const [buzzerClicked, setBuzzerClicked] = useState(false);
  //const [marginTop, setMarginTop] = useState('0px');
  const [isAnimated, setIsAnimated] = useState(false);
  const [selectedBgclick, setselectedBgclick] = useState("blue");
  const [completeduser, setcompleteduser] = useState(false);
  const [seleteduserimgGif, setSeleteduserimgGif] = useState(false);
  const [canUserClickBuzzer, setCanUserClickBuzzer] = useState(false);
  const [textcolor, Setcolorcode] = useState(null);
  //const [riddlerusLogo, SetriddlerusLogo] = useState("./img/logo.png");
  const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
  const [pointerTimestamp, setPointerTimestamp] = useState(null);
  const [clickDisabled, setClickDisabled] = useState(false);

  const [playersDoc, setplayersDoc] = useState([false, false]); // [player, opponent]

  const questionRevealTimerRef = useRef(null);
  const displayedQuestionIndexRef = useRef(0);
  const isFirstLiveSlideSnapshotRef = useRef(true);

  UseHandleConnection({ userId: userData?.userId, sessionId: userData?.sessionId, themeId: themeData?.themeName });


  const handleSuccess = (msg) => {
    Swal.fire({
      icon: "success",
      title: "Success!",
      text: msg,
      customClass: { popup: "custom-success-popup" },
    });
  };

  const handleError = (msg) => {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: msg,
      customClass: { popup: "custom-success-popup" },
    });
  };

  const initalizeRiddle = async () => {
    if (userData != null) {
      try {
        // Step 1: Fetch theme data
        const themeDocRef = doc(
          database,
          `sessions/${userData.sessionId}/themes/${themeData.themeName}`
        );
        const themeSnapshot = await getDoc(themeDocRef);

        if (themeSnapshot.exists()) {
          const themeDataFetch = themeSnapshot.data();
          setWaitingScreen(themeDataFetch.liveData.waiting);
          setIsLive(themeDataFetch.liveData.stat);
          Setcolorcode(themeData.landing_page_title_color);
          console.log("themeDataFetch",themeDataFetch);
        
          //console.log("First Loaded Question Form:", themeDataFetch, themeDataFetch.liveData.stat);
          //console.log("First Loaded Question Form liveData---:", themeDataFetch.liveData.stat);

          const getQuestionsLength = themeDataFetch.questions.length;
          setQuestionForm(themeDataFetch);
          // Step 2: Fetch slide data if the session is live
          if (themeDataFetch.liveData.stat) {
            const slideDoc = doc(
              database,
              `sessions/${userData.sessionId}/reports/${themeData.themeName}`
            );
            const slideSnapshot = await getDoc(slideDoc);
            if (slideSnapshot.exists()) {
              setSlideData(slideSnapshot.data());
              //console.log(slideSnapshot.data());

            }
          }

        } else {
          //console.log("No theme data found!");
        }
      } catch (error) {
        //console.error("Error fetching theme data:", error);
      }
    }
  };

  useEffect(() => {
    console.log("hitting", storedUserData.sessionId);
    //alert(textcolor);

    const alldataCollection = collection(database, 'alldata');

    const filteredQuery = query(
      alldataCollection,
      where("sessionId", "==", storedUserData.sessionId)
    );
    const unsubscribe = onSnapshot(
      filteredQuery,
      (querySnapshot) => {
        const selectedUsers = [];
        const selectedDocIds = [];

        querySnapshot.forEach((docSnapshot) => {
          const docId = docSnapshot.id;

          const data = docSnapshot.data();

          if (data.selected) {
            console.log("data", data);
            selectedUsers.push({ ...data, docId });

            if (data.userId === userData.userId) {
              selectedDocIds[0] = docId;
            } else {
              selectedDocIds[1] = docId;
            }

          }
          console.log("selectedDocIds", selectedDocIds[0], "----", selectedDocIds[1], "--------", selectedDocIds.length);
          if (selectedDocIds.length === 2) {
            setplayersDoc([selectedDocIds[0], selectedDocIds[1]]);
          }

          // ✅ Handle current user
          if (data.userId === userData?.userId) {
            if (data.selected) {
              seleteduserScreen(true);
              seleteduserimgScreen(data.char);
              setcompleteduser(data.completed);
              seletedusernameScreen(data.name);
            } else {
              setcompleteduser(data.completed);
              console.log("getData (not selected):", data.char);
            }
          }

        });


      },
      (error) => {
        console.error("Error fetching Firestore collection: ", error);
      }
    );

    return () => unsubscribe();
  }, [userData]);


  function UpdateCurrentUserTimer() {
    const reportsRef = collection(database, "alldata");

    const queryRef = query(
      reportsRef,
      where("sessionId", "==", userData.sessionId),
      where("userId", "==", userData.userId)
    );

    getDocs(queryRef)
      .then((querySnapshot) => {
        querySnapshot.forEach((docSnapshot) => {
          const docRef = docSnapshot.ref;

          updateDoc(docRef, {
            timestamp: serverTimestamp() // Update the timestamp to server time
          })
            .then(() => {
              console.log("Timestamp updated successfully.");
            })
            .catch((error) => {
              console.error("Error updating timestamp: ", error);
            });
        });
      })
      .catch((error) => {
        console.error("Error fetching documents: ", error);
      });
  }

  useEffect(() => {
    if (userData) {
      initalizeRiddle();
    }
  }, [userData]);

  useEffect(() => {
    if (questionForm.questions != undefined) {
      let getQuestionsLength = questionForm.questions.length;
      console.log("my question form--------------", getQuestionsLength, currentQueston);
      
      if (currentQueston <= getQuestionsLength) {
        console.log("my question form ", questionForm, currentQueston);
        setIsLoaded(true);
        //setCurrentQueston(totalAnswered);
        setIsQuestionCompleted(false);
        //console.log("show them");
      } else {
        setIsQuestionCompleted(true);
        setIsLoaded(true);
        console.log("all questions completed!");
        setcompletiondata();
      }

      //console.log("hitting this ", isLive);
      if (isLive) {
        //console.log(currentQueston);
        //console.log("slidedata", slideData);
        if (slideData?.slideHistory?.[currentQueston] !== undefined) {
          setPointerTimestamp(slideData.slideHistory[currentQueston]);
        }
      }


    }

  }, [questionForm]);

  useEffect(() => {
    //console.log("hitting");
    if (userData != null) {
      isFirstLiveSlideSnapshotRef.current = true;

      //console.log("listner added!");
      const reportDoc = doc(
        database,
        `sessions/${userData.sessionId}/themes/${themeData.themeName}`
      );

      const unsubscribe = onSnapshot(
        reportDoc,
        (docSnapshot) => {
          if (docSnapshot.exists()) {
            if (questionRevealTimerRef.current != null) {
              clearTimeout(questionRevealTimerRef.current);
              questionRevealTimerRef.current = null;
            }

            setselectedBgclick("blue");
            setSeleteduserimgGif(false);

            let getData = docSnapshot.data();
            const nextSlide = getData.liveData.slide;

            setCurrentQueston(nextSlide);
            setIsLoaded(true);
            setIsLive(getData.liveData.stat);
            setIsQuestionCompleted(getData.liveData.completed);

            const buzzerUnlockMs = QUESTION_POPUP_TRANSITION_MS * 2 + 500;

            if (isFirstLiveSlideSnapshotRef.current) {
              isFirstLiveSlideSnapshotRef.current = false;
              displayedQuestionIndexRef.current = nextSlide;
              setDisplayedQuestionIndex(nextSlide);
              setIsAnimated(true);
            } else {
              setIsAnimated(false);
              questionRevealTimerRef.current = setTimeout(() => {
                questionRevealTimerRef.current = null;
                if (displayedQuestionIndexRef.current !== nextSlide) {
                  displayedQuestionIndexRef.current = nextSlide;
                  setDisplayedQuestionIndex(nextSlide);
                }
                setIsAnimated(true);
              }, QUESTION_POPUP_TRANSITION_MS);
            }

            setTimeout(() => {
              setClickDisabled(false);
            }, buzzerUnlockMs);

          } else {
            //console.warn("Document does not exist.");
          }
        },
        (error) => {
          //console.error("Error fetching Firestore document: ", error);
        }
      );

      return () => {
        if (questionRevealTimerRef.current != null) {
          clearTimeout(questionRevealTimerRef.current);
          questionRevealTimerRef.current = null;
        }
        unsubscribe();
      };
    }

  }, [userData]);




  function setcompletiondata() {

    const reportsRef = collection(database, "alldata"); // Reference to the collection

    // Query Firestore for documents with the specified sessionId, userId, and themeId
    const queryRef = query(
      reportsRef,
      where('sessionId', '==', userData.sessionId),
      where('userId', '==', userData.userId)
    );


    getDocs(queryRef) // Retrieve matching documents
      .then((querySnapshot) => {
        const selectedDocsCount = querySnapshot.size;

        if (selectedDocsCount > 0) {
          // If documents are found, update the buzzer click field
          querySnapshot.docs.forEach((docSnapshot) => {
            const documentToUpdate = docSnapshot;
            //console.log("Updating document:", documentToUpdate.id);

            // Check if buzzerClick is already true, to avoid redundant updates
            if (documentToUpdate.data().completed == false) {
              const updateRef = doc(database, "alldata", documentToUpdate.id); // Reference to the document

              updateDoc(updateRef, {
                completed: true,
                buzzerclick: false,
                selected: false,
                timestamp: Timestamp.now() // This provides timestamp with microsecond precision
              })
                .then(() => {
                  console.log("Successfully updated the selected field to true for document:", documentToUpdate.id);
                })
                .catch((error) => {
                  console.error("Error updating document: ", error);
                });
            } else {
              console.log("completed for document:", documentToUpdate.id);
            }
          });
        } else {
          console.log("No matching documents found.");
        }
      })
      .catch((error) => {
        console.error("Error fetching documents: ", error);
      });

  }


  useEffect(() => {
    if (userData != null) {
      const liveCountRef = doc(
        database,
        `sessions/${userData.sessionId}/reports/${themeData.themeName}`
      );

      // Increment the live user count on mount
      updateDoc(liveCountRef, { "live.count": increment(1) })
        .then(() => console.log("Incremented live user count"))
        .catch((error) => {
          if (error.code === "not-found") {
            // If the document doesn't exist, create it with count = 1
            setDoc(liveCountRef, { live: { count: 1 } }, { merge: true })
              .then(() => console.log("Document created and count incremented"))
              .catch((setError) => console.error("Error creating document:", setError));
          } else {
            //console.error("Error incrementing count:", error);
          }
        });

      // Decrement the live user count when the user navigates away
      const handleBeforeUnload = () => {
        updateDoc(liveCountRef, { "live.count": increment(-1) })
          .then(() => console.log("Decremented live user count"))
          .catch((error) => {
            if (error.code === "not-found") {
              // If the document doesn't exist, create it with count = 0 (or leave unchanged)
              setDoc(liveCountRef, { live: { count: 0 } }, { merge: true })
                .then(() => console.log("Document created during decrement"))
                .catch((setError) => console.error("Error creating document during decrement:", setError));
            } else {
              //console.error("Error decrementing count:", error);
            }
          });
      };

      // Attach the event listener
      window.addEventListener("beforeunload", handleBeforeUnload);

      // Cleanup the listener and decrement on component unmount
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
        updateDoc(liveCountRef, { "live.count": increment(-1) })
          .then(() => console.log("Decremented live user count on unmount"))
          .catch((error) => {
            if (error.code === "not-found") {
              // If the document doesn't exist, create it with count = 0 (or leave unchanged)
              setDoc(liveCountRef, { live: { count: 0 } }, { merge: true })
                .then(() => console.log("Document created during unmount decrement"))
                .catch((setError) => console.error("Error creating document during unmount decrement:", setError));
            } else {
              console.error("Error decrementing count on unmount:", error);
            }
          });
      };
    }
  }, [userData]);

  useEffect(() => {
    const storedSession = sessionStorage.getItem('userData');
    const alldata = sessionStorage.getItem('alldata');
    //console.log("alldata0----------" + alldata);
    const themeData = sessionStorage.getItem('themeData');
    if (storedSession && themeData) {
      setThemeData(JSON.parse(themeData));
      setUserData(JSON.parse(storedSession));
      setAllData(alldata);
      //console.log("sessioin state updated!");
    } else {
      navigate('/login');
    }
  }, []);

  useEffect(() => {
    console.log(themeData);
    if (themeData != null) {
      const body = document.body;

      if (body.classList.contains('common-bg')) {
        // Check if it's a mobile device (or you can define your own breakpoint)
        if (window.innerWidth <= 768) {
          // Apply mobile background
          //console.log(themeData.background_mob);
          body.style.backgroundImage = `url(/img/${themeData.main_mob})`;
        } else {
          // Apply desktop background
          //console.log(themeData.background_desk);
          body.style.backgroundImage = `url(/img/${themeData.main_desk})`;
        }
      }

      //SetriddlerusLogo(themeData.logo);
    }
  }, [themeData]);

  const handleBuzzerClick = () => {
   
    setTimeout(() => {
      const audio = new Audio(`/sounds/correct-buzzer.mp3`);
    audio.play().catch(err => console.error("Audio play failed:", err));

    }, 2000);

    if (clickDisabled) return;

    setClickDisabled(true);
    // setTimeout(() => {
    //   setClickDisabled(false);
    // }, 3000);

    const headers = {
      'Content-Type': 'application/json'
    };
    console.log("playersDoc----------", playersDoc);
    const [playerDocId, opponentDocId] = playersDoc;
    const requestData = {
      playerDoc: playerDocId,
      opponentDoc: opponentDocId,

    };

    //console.log(requestData);

    axios.post(process.env.REACT_APP_FIREBASE_BUZZER_CLICK_API, requestData, { headers })
      .then(response => {
        console.log("API TRIGGER", response);
        if (response.data.success) {
          setSeleteduserimgGif(true);
          UpdateCurrentUserTimer();
          //Swal.fire("Error", "Another player has already clicked the buzzer!", "error");
          // return;
        } else {
          handleError(response.data.message);
        }
      })
      .catch(error => {
        console.error('Login Failed:', error || 'An error occurred');
        //handleError('Login failed! Please try again.');
      });

  };


  return (
    <>
      <div className="userpage-main-container" style={{ textAlign: "center" }}>
        {completeduser ? ( // If user has completed, show thank you message
          <div className="finalcomplete" style={{ color: textcolor }}>Thank you For Participating</div>
        ) : !isQuestionCompleted ? (
          seleteduser ? (
            isLoaded && isLive ? (
              <div>
                <div className={`question-screen ${isAnimated ? "animated" : ""}`}>
                  <div className="question-area">
                    {questionForm?.questions[displayedQuestionIndex]?.text}
                  </div>
                </div>

                <div className="user-main-container" style={{ textAlign: "center" }}>
                  <img
                    src={`/img/${seleteduserimgGif ? seleteduserimg + ".gif" : seleteduserimg + ".png"}`}
                    alt="Character"
                    id="character"
                    onClick={handleBuzzerClick}
                    style={{ cursor: clickDisabled ? "not-allowed" : "pointer" }}
                  />
                  <div className="parent">
                    <div className="username">{seletedusername}</div>

                  </div>
                </div>
                <div className="Rightimage">
                  <img src={`/img/host.png`}></img>
                </div>


              </div>
            ) : (
              <div className="wrapper">
                <div className="user-main-container" style={{ textAlign: "center" }}>
                  <img
                    src={`/img/${seleteduserimg}${seleteduserimgGif ? ".gif" : ".png"}`}
                    alt="Character"
                    id="character"
                  />
                  <div className="parent">
                    <div className="username" style={{ color: textcolor }}>{seletedusername}</div>
                  </div>
                </div>

                <div className="Rightimage">
                  <img src="/img/host.png" alt="Host" className="host-image" />
                </div>
              </div>



            )
          ) : (
            <div className="waiting-screen">
              <div className="screen">
                <div className="loader">
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
              </div>
            </div>
          )
        ) : (
          <div className="waiting-screen">
            <div className="screen">
              <div className="loader">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
            </div>
          </div>
        )}
      </div>


    </>
  );
}
export default UserPage;